import { restApi } from '../../api';
import { FindActiveBannersOutput } from './banners.types';

export const findActiveBanners = (limit: number) =>
  restApi.get<FindActiveBannersOutput>('banners', { active: true, limit });
